// On mobile, allow a single tap on a product card to navigate to the product page
(function () {
  const MOBILE_BREAKPOINT = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function isInteractiveTarget(target) {
    if (!(target instanceof Element)) return false;
    // Rimuovo swatches-variant-picker-component dalla lista per permettere il click diretto
    return !!target.closest(
      'button:not(.variant-option__button-label), input, select, textarea, [role="button"]:not(.variant-option__button-label), .quick-add__button, product-form-component button'
    );
  }

  // Nascondi gli swatches su mobile
  function hideSwatchesOnMobile() {
    if (isMobile()) {
      document.body.classList.add('mobile-hide-swatches');
    } else {
      document.body.classList.remove('mobile-hide-swatches');
    }
  }

  // Applica all'avvio e al resize
  hideSwatchesOnMobile();
  window.addEventListener('resize', hideSwatchesOnMobile);

  document.addEventListener('click', (event) => {
    try {
      if (!isMobile()) return;
      if (event.defaultPrevented) return;

      const target = /** @type {Element} */ (event.target);
      const card = target.closest('.product-card');
      if (!card) return;

      // Se clicco direttamente sul link del prodotto, lascia funzionare normalmente
      const productLink = target.closest('a.product-card__link');
      if (productLink) return;

      // Se clicco su swatches o varianti, vai alla pagina prodotto invece
      const swatchClick = target.closest('swatches-variant-picker-component, variant-picker, .variant-option__button-label');
      if (swatchClick) {
        event.preventDefault();
        event.stopPropagation();
        const link = card.querySelector('a.product-card__link');
        if (link && link.href) {
          window.location.assign(link.href);
        }
        return;
      }

      // If the click was on an interactive element inside the card, don't override
      const interactive = isInteractiveTarget(target);
      if (interactive) return;

      // Find the full-card link and navigate
      const link = card.querySelector('a.product-card__link');
      if (link && link.href) {
        // Use location.assign to keep back button behaviour predictable
        window.location.assign(link.href);
      }
    } catch (err) {
      // swallow errors to avoid breaking page behavior
      console.error('product-card-tap-to-open error', err);
    }
  }, { passive: false });
})();
